import { LANGUAGE_MAP } from './languages';

/**
 * ISO language codes offered on ToHear / PlatzView upload forms (content language,
 * not UI locale). Keep this list curated and easy to extend — labels come from
 * LANGUAGE_MAP.nativeName with optional `upload.languages.${code}` i18n override.
 */
export const UPLOAD_CONTENT_LANGUAGE_CODES = [
  'en',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'pt-BR',
  'nl',
  'pl',
  'ru',
  'uk',
  'tr',
  'ar',
  'he',
  'hi',
  'ja',
  'ko',
  'zh',
  'zh-TW',
  'sv',
  'da',
  'fi',
  'no',
  'cs',
  'sk',
  'hu',
  'ro',
  'bg',
  'el',
  'th',
  'vi',
  'id',
  'ms',
  'bn',
  'ur',
  'fa',
  'sw',
] as const;

export type UploadContentLanguageCode = (typeof UPLOAD_CONTENT_LANGUAGE_CODES)[number];

export interface UploadContentLanguage {
  code: UploadContentLanguageCode;
  /** Native script label — preferred for language pickers */
  nativeName: string;
  englishName: string;
  /** i18n key under upload.languages.* when a locale provides an override */
  labelKey: string;
}

export const UPLOAD_CONTENT_LANGUAGES: UploadContentLanguage[] = UPLOAD_CONTENT_LANGUAGE_CODES.map((code) => {
  const def = LANGUAGE_MAP[code];
  return {
    code,
    nativeName: def?.nativeName ?? code,
    englishName: def?.englishName ?? code,
    labelKey: `upload.languages.${code}`,
  };
});

export function uploadLanguageLabel(code: string): string {
  return LANGUAGE_MAP[code]?.nativeName ?? code;
}
